import { treaty } from "@elysiajs/eden";
import type { App } from "@upsquad/server";
import { env } from "@/src/common/constants/env";

let accessToken: string | null = null;
let refreshToken: string | null = null;

export const setAccessToken = (token: string) => {
	accessToken = token;
};

export const clearAccessToken = () => {
	accessToken = null;
};

export const clearRefreshToken = () => {
	refreshToken = null;
};

export const getAccessToken = () => accessToken;

export const setRefreshToken = (token: string) => {
	refreshToken = token;
};

export const getRefreshToken = () => refreshToken;

export const httpClient = treaty<App>(env.SERVER_URL, {
	parseDate: false,
	fetch: { credentials: "include" },
	onRequest: async (_path, options) => {
		return {
			...options,
			headers: {
				...options.headers,
				...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
			},
		};
	},
	onResponse: async (response) => {
		if (response.status === 422) {
			const data = await response.json();
			throw new Error(data.message);
		}
	},
});
